<script>
  import formatDate from '@utils/format-date'
  import BulletinItem from '@components/List/BulletinItem'

  export default {
    components: {
      BulletinItem,
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
      isRowItem: {
        type: Boolean,
        default: false,
      },
      contentType: {
        type: String,
        default: 'news',
        validator(value) {
          return [
            'news',
            'video',
          ].includes(value)
        },
      }
    },
    data() {
      return {
        formatDate,
        // isDialogLoginVisible: false,
        
      }
    },
    methods: {
      goToView(item) {
        if(item.isdealer) {
          this.$emit('goTo',item)
        } else {
          this.$router.push(item.to)
        }
      },
    },
  }
</script>
<template>
  <div class="row">
    <div 
      v-for="(item, $index) in list" 
      :key="$index" :class="[$style.bulletinItem ,{ 'col-lg-6': !isRowItem, 'col-12': isRowItem }]"
    >
      <BulletinItem 
        :item="item" 
        :is-row-item="isRowItem"
        :content-type="contentType"
        @goTo="goToView"
      />
    </div>
  </div>
</template>
<style lang="scss" module>
  .bulletinItem {
    &:not(:last-child) {
      margin-bottom: 2rem;
    }
  }
  .bulletin {
    display: flex;
    padding: 2.5rem;
    // margin-bottom: 2rem;
    color: $color-gray-6;
    background-color: #FFF;
    transition: all 0.35s;
    position: relative;
    @include max-lg {
      padding: 0;
      border-radius: 5px; 
      overflow: hidden;
    }

    &:hover {
      color: $color-gray-7;
      text-decoration: none;
    }


    :global {
      .bulletin {
        &__img {
          position: relative;
          z-index: 0;
          width:  25%;
          cursor: pointer;
          // background: $color-gray-2;
          background-position: center;
          background-size: cover;
          padding-top: 25%;
          @include max-lg {
            width: 31%;
            padding-top: 31%;
          }
          // width: 96px;
          // height: 96px;
          // padding-top: 30% !important;

          // @include min-md {
          //   width: 25%;
          //   padding-top: 25% !important;
          // }
        }

        &__content {
          display: flex;
          flex-direction: column;
          width: 75%;
          padding-left: 2.4rem;

          @include max-lg {
            // width: 100%;
            padding: 1rem 0.75rem 1.125rem 0.75rem;
            width: 69%;
            // margin-top: 1rem;
          }
        }

        &__logo {
          height: 28px;

          @include max-lg {
            height: 28px;
          }
        }

        &__title {
          width: 100%;
          font-size: 1.35rem;
          line-height: 1.5;
          color: $color-gray-7;

          @include line-clamp(2, 3em);

          @include max-lg {
            font-size: 1rem;
            @include line-clamp(3, 4.3em);
          }
          @include max-md {
            font-size: 0.875rem;
            line-height: 1.42;
          }
        }

        &__info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          margin-bottom: 0.8rem;
          @include max-lg {
            height: 25px;
          }
          .badge {
            @include max-lg {
              padding: 0.5rem;
              font-size: 12px;
            }
          }
        }
        &__top {
          position: absolute;
          top: 10px;
          right: 10px;
        }
      }

      .clip-img {
        position: absolute;
        object-fit: contain;
        top: 0;
        width: 100%;
        height: 100%;
        object-position: center center;
        padding: 0 15px;
      }
    }

    &:global {
      &.isRowItem {
        @include max-lg {
          box-shadow: 0px 2px 6px #21455817;
          &:hover {
            box-shadow: 0 10px 25px rgb(33 69 88 / 16%);
          }
        }
        .bulletin__img {
          width: 22%;
          padding-top: 22%;
          @include max-lg {
            width: 31%;
            padding-top: 31%;
          }
        }
        .bulletin__content {
          padding-left: 4.5rem;
          margin: 2rem 0 0.5rem 0;
          width: 78%;
          @include max-lg {
            padding: 2.5rem;
            margin: 0;
          }
          @include max-lg {
            padding: 1rem 0.75rem 1.125rem 0.75rem;
            width: 69%;
          }
        }

        .bulletin__title {
          font-size: 1.875rem;

          @include max-lg {
            margin-top: 0.5rem;
            font-size: 1.25rem;
            @include line-clamp(2, 3em);
          }
          @include max-md {
            margin-top: 0;
            font-size: 0.875rem;
            @include line-clamp(3, 4.3em);
          }
        }
        .bulletin__introtext {
          @include line-clamp(2, 3em);
        }

      }
    }
  }

</style>
